function oRequest_APIEngine(engine) {
  this.engine = engine;
}

oRequest_APIEngine.prototype = {
  get: function (url, callback) {
    let o = this;
    this.engine.request.security.auth.get(url, function (auth_url) {
      o.engine.request.getAjax("GET", "json", auth_url, true, null, callback);
    });
  },
  post: function (url, data, callback) {
    let o = this;
    this.engine.request.security.auth.get(url, function (auth_url) {
      o.engine.request.getAjax("POST", "json", auth_url, true, data, callback);
    });
  },
  // 导入
  Import: function(data,callback) {
    let o = this;
    this.engine.request.security.auth.get("/charging_pile/qianniuTwo/upload", function (auth_url) {
      o.engine.request.getExport(auth_url, data,callback);
    });
  },
  upload: function (data, beforeCallback, completedCallback) {
    let o = this;
    this.engine.request.security.auth.get("/Octopus/Engine/Upload", function (auth_url) {
      o.engine.request.getUpload(auth_url, data, beforeCallback, completedCallback);
    });
  },
  export: function (name, data, callback) {
    let o = this;
    this.engine.request.security.auth.get("/Octopus/Engine/Export", function (auth_url) {
      // o.engine.request.getAjax("POST", "json", auth_url + "&fileName=sadadsad", true, data, callback);
      let param = {
        FILENAME: name,
        FILEDATA: data
      };
      let form = $('<form></form>');
      form.attr('action', auth_url + "&r=" + Math.random());
      form.attr('method', 'post');
      for (let item in param) {
        var input = $('<input type="text" />');
        input.attr('value', JSON.stringify(param[item]));
        input.attr('name', item);
        form.append(input);
      }
      form.appendTo('body').submit().remove();


      // 如果有回调，则触发。
      if (callback) {
        callback({
          content: param,
          status: {
            code: 200,
            message: "Success."
          }
        });
      }
    });
  },
}

export {
  oRequest_APIEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/request_api.js